var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_27463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16732 15.0007C9.16732 15.9173 8.41732 16.6673 7.50065 16.6673C6.58398 16.6673 5.83398 15.9173 5.83398 15.0007C5.83398 14.084 6.58398 13.334 7.50065 13.334C8.41732 13.334 9.16732 14.084 9.16732 15.0007ZM7.50065 8.33398C6.58398 8.33398 5.83398 9.08398 5.83398 10.0007C5.83398 10.9173 6.58398 11.6673 7.50065 11.6673C8.41732 11.6673 9.16732 10.9173 9.16732 10.0007C9.16732 9.08398 8.41732 8.33398 7.50065 8.33398ZM7.50065 3.33398C6.58398 3.33398 5.83398 4.08398 5.83398 5.00065C5.83398 5.91732 6.58398 6.66732 7.50065 6.66732C8.41732 6.66732 9.16732 5.91732 9.16732 5.00065C9.16732 4.08398 8.41732 3.33398 7.50065 3.33398ZM12.5007 6.66732C13.4173 6.66732 14.1673 5.91732 14.1673 5.00065C14.1673 4.08398 13.4173 3.33398 12.5007 3.33398C11.584 3.33398 10.834 4.08398 10.834 5.00065C10.834 5.91732 11.584 6.66732 12.5007 6.66732ZM12.5007 8.33398C11.584 8.33398 10.834 9.08398 10.834 10.0007C10.834 10.9173 11.584 11.6673 12.5007 11.6673C13.4173 11.6673 14.1673 10.9173 14.1673 10.0007C14.1673 9.08398 13.4173 8.33398 12.5007 8.33398ZM12.5007 13.334C11.584 13.334 10.834 14.084 10.834 15.0007C10.834 15.9173 11.584 16.6673 12.5007 16.6673C13.4173 16.6673 14.1673 15.9173 14.1673 15.0007C14.1673 14.084 13.4173 13.334 12.5007 13.334Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_27463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.a90d7e58840cc9ad94b1b265178af530.svg";
export { ForwardRef as ReactComponent };